<template>
  <container 
    subHeaderTitle="진행 중인<br /><b>채용 공고</b>안내" 
    subHeaderText="우리와 함께하고 싶은지 진지하게 고민하였고, 새로운 방식으로 새로운 서비스를 만들어 보고 싶다면 아래의 기회를 확인하세요.<br />채용 문의  |  hr@finbridge.co.kr"
  >
    <section class="jobs-top">
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" xl="8" offset-xl="2" class="py-0">
            <v-row>
              <v-col cols="12" sm="4" md="6">
                <img src="@/assets/new/image/career/jobs_icon_1.svg" alt="icon" />
                <p class="text-title">지원 전에<br />꼭 확인해 주세요</p>
              </v-col>
              <v-col cols="12" sm="8" md="6">
                  <p class="text-content">
                    채용 절차  |  서류 전형 - 1차 인터뷰 - 2차 인터뷰 - 채용 확정<br />
                    지원 양식  |  별도 양식은 없으며, 본인의 강점으로 구성하여 제출<br />
                    경력 지원  |  경력기술서 제출(기간, 주요 내용, 기여도, 결과 등  / word, pdf)<br />
                    인터뷰  |  서류 합격자에 한해 개별 연락 (비대면 선택 가능)
                  </p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section class="jobs-list">
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" xl="8" offset-xl="2" class="py-0">
            <router-view></router-view>
            <!-- <board-list category="jobs" :list="list"></board-list> -->
          </v-col>
        </v-row>
      </v-container>
    </section>
  </container>
</template>

<style lang="scss">
@import "@/styles/career";
</style>


<script>
import Container from "@/pages/container/index.vue";

export default {
  mixins: [],
  name: "CareerJobs",
  components: {
    Container
  },
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {}
};
</script>